/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationPricingsSelfWorkerQuery from '../graphql/queries/GetSimulationPricingsSelfWorkerQuery.js';

const useGetSimulationPricingsSelfWorkerQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationPricingsSelfWorkerQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationPricingsSelfWorker: R.omit(['__typename'], data?.getSimulationPricingsSelfWorker_simulation_pricings_self_worker || {})
  };
};

export default useGetSimulationPricingsSelfWorkerQuery;
